import CescoMain from "../../../../src/events/2022/06/cescoMain/main";
import * as React from 'react';
export default {
  CescoMain,
  React
};